import React, { Component } from 'react';
import { MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBTable, MDBTableHead, MDBTableBody, MDBIcon, MDBModal, MDBModalHeader, MDBModalBody, MDBModalFooter, MDBRow, MDBCol } from 'mdbreact';
import axios from 'axios';
import ConfigData from '../Components/config';

export default class ShowDetailPetition extends Component {

    constructor(props) {
        super(props)
        this.state = {
            modaledit: false,
            DETAILPITITION_ID: null,
            DETAILPITITION_NAME: null,
            DETAILPITITION_NAMEENG: null,
            DETAILPITITION_STATUS: null,
            KI1: false,
            KI2: false,
            KI3: false,
            KI4: false,
            KI5: false,
            KI6: false,
            KI7: false,
            DETAILPITITION_KI1: null,
            DETAILPITITION_KI2: null,
            DETAILPITITION_KI3: null,
            DETAILPITITION_KI4: null,
            DETAILPITITION_KI5: null,
            DETAILPITITION_KI6: null,
            DETAILPITITION_KI7: null,

            array_ShowDetailPetition: [],
            array_Statusstudent: [],
            tableFilter: "",
            tablePage: 1
        }
        this.modaladd_open = this.modaladd_open.bind(this);
        this.modaledit_open = this.modaledit_open.bind(this);
        this.modaledit_close = this.modaledit_close.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleKIChange = this.handleKIChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        if (!(localStorage.getItem('token'))) {
            window.location.href = '/rubrongkpru'
        }
        axios.get(ConfigData.SERVER_URL + 'FrontEnd_Tabian/petition/ShowDetailPetition/').then((ShowDetailPetition) => {
            if (ShowDetailPetition.data.length !== 0) {
                this.setState({ array_ShowDetailPetition: ShowDetailPetition.data })
            }
        })

        this.setState({
            array_Statusstudent: [
                { value: '1', label: 'ยังคงสถานะนักศึกษา' },
                { value: '2', label: 'จบการศึกษา' },
                { value: '3', label: 'อื่นๆ' },
            ]
        })
    }

    modaladd_open(event) {
        event.preventDefault();
        this.setState({ modaledit: true })
    }

    modaledit_open(event) {
        this.setState({ modaledit: true })
        this.setState({ DETAILPITITION_ID: this.state.array_ShowDetailPetition[event.target.value]['DETAILPITITION_ID'] });
        this.setState({ DETAILPITITION_NAME: this.state.array_ShowDetailPetition[event.target.value]['DETAILPITITION_NAME'] });
        this.setState({ DETAILPITITION_NAMEENG: this.state.array_ShowDetailPetition[event.target.value]['DETAILPITITION_NAMEENG'] });
        this.setState({ DETAILPITITION_STATUS: this.state.array_ShowDetailPetition[event.target.value]['DETAILPITITION_STATUS'] });
        if (this.state.array_ShowDetailPetition[event.target.value]['DETAILPITITION_KI'].search("1") >= 0) {
            this.setState({ KI1: true });
            this.setState({ DETAILPITITION_KI1: "1" });
        }
        if (this.state.array_ShowDetailPetition[event.target.value]['DETAILPITITION_KI'].search("2") >= 0) {
            this.setState({ KI2: true });
            this.setState({ DETAILPITITION_KI2: "2" });
        }
        if (this.state.array_ShowDetailPetition[event.target.value]['DETAILPITITION_KI'].search("3") >= 0) {
            this.setState({ KI3: true });
            this.setState({ DETAILPITITION_KI3: "3" });
        }
        if (this.state.array_ShowDetailPetition[event.target.value]['DETAILPITITION_KI'].search("4") >= 0) {
            this.setState({ KI4: true });
            this.setState({ DETAILPITITION_KI4: "4" });
        }
        if (this.state.array_ShowDetailPetition[event.target.value]['DETAILPITITION_KI'].search("5") >= 0) {
            this.setState({ KI5: true });
            this.setState({ DETAILPITITION_KI5: "5" });
        }
        if (this.state.array_ShowDetailPetition[event.target.value]['DETAILPITITION_KI'].search("6") >= 0) {
            this.setState({ KI6: true });
            this.setState({ DETAILPITITION_KI6: "6" });
        }
        if (this.state.array_ShowDetailPetition[event.target.value]['DETAILPITITION_KI'].search("7") >= 0) {
            this.setState({ KI7: true });
            this.setState({ DETAILPITITION_KI7: "7" });
        }
    }

    modaledit_close(event) {
        this.setState({ modaledit: false })
        this.setState({ DETAILPITITION_ID: null });
        this.setState({ DETAILPITITION_NAME: null });
        this.setState({ DETAILPITITION_NAMEENG: null });
        this.setState({ DETAILPITITION_STATUS: null });
        this.setState({ KI1: false });
        this.setState({ KI2: false });
        this.setState({ KI3: false });
        this.setState({ KI4: false });
        this.setState({ KI5: false });
        this.setState({ KI6: false });
        this.setState({ KI7: false });
        this.setState({ DETAILPITITION_KI1: null });
        this.setState({ DETAILPITITION_KI2: null });
        this.setState({ DETAILPITITION_KI3: null });
        this.setState({ DETAILPITITION_KI4: null });
        this.setState({ DETAILPITITION_KI5: null });
        this.setState({ DETAILPITITION_KI6: null });
        this.setState({ DETAILPITITION_KI7: null });
    }

    handleChange(event) {
        this.setState({ [event.target.name]: event.target.value })
    }

    handleKIChange(event) {
        this.setState({ [event.target.name]: event.target.checked })
        if (event.target.checked) {
            this.setState({ ["DETAILPITITION_" + event.target.name]: event.target.value })
        } else {
            this.setState({ ["DETAILPITITION_" + event.target.name]: null })
        }
    }

    handleSubmit(event) {
        event.preventDefault();
        var DETAILPITITION_KI = "";
        if (this.state.DETAILPITITION_KI1 === "1") {
            DETAILPITITION_KI += this.state.DETAILPITITION_KI1;
        }
        if (this.state.DETAILPITITION_KI5 === "5") {
            DETAILPITITION_KI += this.state.DETAILPITITION_KI5;
        }
        if (this.state.DETAILPITITION_KI2 === "2") {
            DETAILPITITION_KI += this.state.DETAILPITITION_KI2;
        }
        if (this.state.DETAILPITITION_KI3 === "3") {
            DETAILPITITION_KI += this.state.DETAILPITITION_KI3;
        }
        if (this.state.DETAILPITITION_KI6 === "6") {
            DETAILPITITION_KI += this.state.DETAILPITITION_KI6;
        }
        if (this.state.DETAILPITITION_KI4 === "4") {
            DETAILPITITION_KI += this.state.DETAILPITITION_KI4;
        }
        if (this.state.DETAILPITITION_KI7 === "7") {
            DETAILPITITION_KI += this.state.DETAILPITITION_KI7;
        }

        let bodydata = {
            DETAILPITITION_NAME: this.state.DETAILPITITION_NAME,
            DETAILPITITION_NAMEENG: this.state.DETAILPITITION_NAMEENG,
            DETAILPITITION_STATUS: this.state.DETAILPITITION_STATUS,
            DETAILPITITION_KI: DETAILPITITION_KI
        }
        if (this.state.DETAILPITITION_ID) {
            axios.post(ConfigData.SERVER_URL + 'FrontEnd_Tabian/petition/UpdateDetailPetition/' + this.state.DETAILPITITION_ID, bodydata).then((data) => {
                if (data.data === 1) {
                    window.location.href = 'Showreason';
                }
            })
        } else {
            axios.post(ConfigData.SERVER_URL + 'FrontEnd_Tabian/petition/InsertDetailPetition/', bodydata).then((data) => {
                if (data.data === 1) {
                    window.location.href = 'Showreason';
                }
            })
        }
    }

    handleTableFilter = (event) => {
        this.setState({ tableFilter: event.target.value, tablePage: 1 });
    };

    getVisibleRows(list) {
        const q = (this.state.tableFilter || "").trim().toLowerCase();
        let rows = (list || []).map((data, index) => ({ data, index }));
        if (q) {
            rows = rows.filter(({ data }) =>
                Object.values(data)
                    .filter((value) => value !== null && value !== undefined && typeof value !== "object")
                    .join(" ")
                    .toLowerCase()
                    .includes(q)
            );
        }
        const pageSize = 30;
        const pages = Math.max(1, Math.ceil(rows.length / pageSize));
        const page = Math.min(this.state.tablePage || 1, pages);
        return {
            rows: rows.slice((page - 1) * pageSize, page * pageSize),
            total: rows.length,
            page,
            pages,
        };
    }

    render() {
        const visibleReasons = this.getVisibleRows(this.state.array_ShowDetailPetition);
        return (<>
            <span className="white-text mt-3" style={{ fontSize: '22px' }}>สถานะการขอใบรับรอง</span><span className="white-text mt-3" style={{ fontSize: '16px' }}> มหาวิทยาลัยราชภัฏกำแพงเพชร</span>
            <MDBCard className="mt-3">
                <MDBCardBody>
                    <MDBCardTitle className="h5">
                        สถานะการขอใบรับรอง <button className="btn btn-success btn-md" onClick={this.modaladd_open}><MDBIcon icon="plus" /> เพิ่มใบรับรอง</button>
                        {/* สถานะการขอใบรับรอง <a className="btn btn-success btn-md" href="#"><MDBIcon icon="plus" /> เพิ่มใบรับรอง</a> */}
                        {/* สถานะการขอใบรับรอง <a className="btn btn-success btn-md" href="/rubrongkpru/Addpetition"><MDBIcon icon="plus" /> เพิ่มใบรับรอง</a> */}
                    </MDBCardTitle>
                    <MDBCardText>
                        <span className="text-danger">
                            หมายเหตุุ
                            <MDBRow>
                                <MDBCol lg="6" md="12" sm="12">
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;สถานะนักศึกษา มีดังนี้
                                    <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1&nbsp;&nbsp;&nbsp;&nbsp;หมายถึง&nbsp;ยังคงสถานะนักศึกษา
                                    <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2&nbsp;&nbsp;&nbsp;&nbsp;หมายถึง&nbsp;จบการศึกษา
                                    <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3&nbsp;&nbsp;&nbsp;&nbsp;หมายถึง&nbsp;อื่นๆ
                                </MDBCol>
                                <MDBCol lg="6" md="12" sm="12">
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ประเภทนักศึกษา มีดังนี้
                                    <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1&nbsp;&nbsp;&nbsp;&nbsp;หมายถึง&nbsp;นักศึกษาปริญญาตรี ภาคปกติ (กำแพงเพชร)
                                    <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2&nbsp;&nbsp;&nbsp;&nbsp;หมายถึง&nbsp;นักศึกษาปริญญาตรี ภาคกศ.บป. (กำแพงเพชร)
                                    <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3&nbsp;&nbsp;&nbsp;&nbsp;หมายถึง&nbsp;นักศึกษาปริญญาตรี ภาคกศ.บป. (กำแพงเพชร แม่สอด)
                                    <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4&nbsp;&nbsp;&nbsp;&nbsp;หมายถึง&nbsp;นักศึกษาปริญญาโท
                                    <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5&nbsp;&nbsp;&nbsp;&nbsp;หมายถึง&nbsp;นักศึกษาปริญญาตรี ภาคปกติ (กำแพงเพชร แม่สอด)
                                    <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;6&nbsp;&nbsp;&nbsp;&nbsp;หมายถึง&nbsp;นักศึกษาป.วิชาชีพครู
                                    <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7&nbsp;&nbsp;&nbsp;&nbsp;หมายถึง&nbsp;นักศึกษาปริญญาเอก
                                </MDBCol>
                            </MDBRow>
                        </span>
                        <div className="app-table-toolbar">
                            <input
                                type="search"
                                className="form-control app-table-search"
                                placeholder="ค้นหา..."
                                value={this.state.tableFilter}
                                onChange={this.handleTableFilter}
                            />
                        </div>
                        <MDBTable bordered striped responsive>
                            <MDBTableHead color="teal" textWhite>
                                <tr>
                                    <th className="text-align">ลำดับ</th>
                                    <th className="text-align">เหตุผลภาษาไทย</th>
                                    <th className="text-align">เหตุผลภาษาอังกฤษ</th>
                                    <th className="text-align">สถานะนักศึกษา</th>
                                    <th className="text-align">ประเภทนักศึกษา</th>
                                    <th className="text-align">จัดการ</th>
                                </tr>
                            </MDBTableHead>
                            <MDBTableBody>
                                {visibleReasons.rows.map(({ data, index }) => {
                                    return <tr>
                                        <td className="text-align">{index + 1}</td>
                                        <td>{data.DETAILPITITION_NAME}</td>
                                        <td>{data.DETAILPITITION_NAMEENG}</td>
                                        <td className="text-align">{data.DETAILPITITION_STATUS}</td>
                                        <td className="text-align">{data.DETAILPITITION_KI}</td>
                                        <td className="text-align">
                                            <button type="button" className="btn btn-info btn-sm" value={index} onClick={this.modaledit_open}><i className="fas fa-edit"></i> แก้ไข</button>
                                        </td>
                                    </tr>
                                })}
                            </MDBTableBody>
                        </MDBTable>
                        {visibleReasons.pages > 1 ? (
                            <div className="app-table-pager">
                                <button type="button" className="btn btn-sm btn-light" disabled={visibleReasons.page <= 1} onClick={() => this.setState({ tablePage: visibleReasons.page - 1 })}>ก่อนหน้า</button>
                                <span>หน้า {visibleReasons.page} / {visibleReasons.pages} ({visibleReasons.total} รายการ)</span>
                                <button type="button" className="btn btn-sm btn-light" disabled={visibleReasons.page >= visibleReasons.pages} onClick={() => this.setState({ tablePage: visibleReasons.page + 1 })}>ถัดไป</button>
                            </div>
                        ) : null}
                    </MDBCardText>
                </MDBCardBody>
            </MDBCard>

            <MDBModal isOpen={this.state.modaledit} toggle={this.modaledit_close} centered>
                <MDBModalHeader toggle={this.modaledit_close}>รายละเอียดคำร้องและเหตุผลประกอบ</MDBModalHeader>
                <form onSubmit={this.handleSubmit}>
                    <MDBModalBody>
                        <div className="form-outline mt-2">
                            <label className="form-label" for="DETAILPITITION_NAME">รายละเอียดคำร้องและเหตุผลประกอบภาษาไทย</label>
                            <input type="text" className="form-control" id="DETAILPITITION_NAME" name="DETAILPITITION_NAME" placeholder="รายละเอียดคำร้องและเหตุผลประกอบภาษาไทย" value={this.state.DETAILPITITION_NAME} onChange={this.handleChange} required />
                        </div>

                        <div className="form-outline mt-2">
                            <label className="form-label" for="DETAILPITITION_NAMEENG">รายละเอียดคำร้องและเหตุผลประกอบภาษาอังกฤษ</label>
                            <input type="text" className="form-control" id="DETAILPITITION_NAMEENG" name="DETAILPITITION_NAMEENG" placeholder="รายละเอียดคำร้องและเหตุผลประกอบภาษาอังกฤษ" value={this.state.DETAILPITITION_NAMEENG} onChange={this.handleChange} />
                        </div>

                        <div className="form-outline mt-2">
                            <label className="form-label" for="DETAILPITITION_STATUS">สถานะนักศึกษา</label>
                            <select class="form-control" id="DETAILPITITION_STATUS" name="DETAILPITITION_STATUS" value={this.state.DETAILPITITION_STATUS} onChange={this.handleChange} required>
                                <option value="" hidden>---ระบุสถานะนักศึกษา---</option>
                                {this.state.array_Statusstudent.map((data) => {
                                    return data.value === this.state.DETAILPITITION_STATUS ? <>
                                        <option value={data.value} selected>{data.label}</option>
                                    </> : <>
                                        <option value={data.value}>{data.label}</option>
                                    </>
                                })}
                            </select>
                        </div>

                        <div className="form-outline mt-2">
                            <label className="form-label">ประเภทนักศึกษา</label>
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="KI1" name="KI1" value="1" checked={this.state.KI1} onChange={this.handleKIChange} />
                                <label class="form-check-label" for="KI1"> นักศึกษาปริญญาตรี ภาคปกติ (กำแพงเพชร)</label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="KI2" name="KI2" value="2" checked={this.state.KI2} onChange={this.handleKIChange} />
                                <label class="form-check-label" for="KI2"> นักศึกษาปริญญาตรี ภาคกศ.บป. (กำแพงเพชร)</label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="KI3" name="KI3" value="3" checked={this.state.KI3} onChange={this.handleKIChange} />
                                <label class="form-check-label" for="KI3"> นักศึกษาปริญญาตรี ภาคกศ.บป. (กำแพงเพชร แม่สอด)</label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="KI4" name="KI4" value="4" checked={this.state.KI4} onChange={this.handleKIChange} />
                                <label class="form-check-label" for="KI4"> นักศึกษาปริญญาโท</label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="KI5" name="KI5" value="5" checked={this.state.KI5} onChange={this.handleKIChange} />
                                <label class="form-check-label" for="KI5"> นักศึกษาปริญญาตรี ภาคปกติ (กำแพงเพชร แม่สอด)</label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="KI6" name="KI6" value="6" checked={this.state.KI6} onChange={this.handleKIChange} />
                                <label class="form-check-label" for="KI6"> นักศึกษาป.วิชาชีพครู</label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="KI7" name="KI7" value="7" checked={this.state.KI7} onChange={this.handleKIChange} />
                                <label class="form-check-label" for="KI7"> นักศึกษาปริญญาเอก</label>
                            </div>
                        </div>

                    </MDBModalBody>
                    <MDBModalFooter>
                        <button type="submit" className="btn btn-primary btn-md">บันทึกข้อมูล</button>
                        <button type="button" className="btn btn-danger btn-md" onClick={this.modaledit_close}>ยกเลิก</button>
                    </MDBModalFooter>
                </form>
            </MDBModal>
        </>)
    }
}
